import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Form, Schema } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons';
import Issues from '../../../../../Shared/Card/Issues';
import { useSelector } from 'react-redux';
import ViolationService from '../../../../../../services/Public/Application/VF/violation.service';
import applicationService from '../../../../../../services/Public/Application/VF/vfApplication.service';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import { GetAppInformationContent } from '../../../../../Shared/InformationContent/VFInformation';
import Information from '../../../../../Shared/Card/Information';
import { getCodeViolationAnswers } from '../../../../../../services/Shared/codeTable.service';
import GenericViolations from '../../../../../Shared/Card/Violations';

function Violations() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [sectionData, setSectionData] = useState({});
    const routes = useSelector(x => x.currentRoutes);
    const sectionId = 4;
    const { StringType } = Schema.Types;
    
    useEffect(() => {
        setHasLoaded(false);
        applicationService.vfGetSection(store.currentApplicationId, sectionId).then((response) => {
            ViolationService.getViolation(store.currentApplicationId).then((data) => {
                if (data.data) {
                    updateFormData({ ...data.data, issues: formData.issues, files: formData.files, filesForDisplay: formData.filesForDisplay });
                }
                else {
                    getCodeViolationAnswers(8).then((questions) => {
                        updateFormData({ ...formData, answers: [...questions] })
                    })
                }
                setSectionData(response.data);
                setHasLoaded(true);
            })
        })

    }, [])
    const store = useSelector(x => x);

    const initialFormData = Object({
        id: 0,
        question1: undefined,
        question2: undefined,
        question3: undefined,
        question4: undefined,
        yesAnswerExplanation: "",
        files: [],
        filesForDisplay: [],
        issues: []
    });

    const push = useNavigate();
    const [formData, updateFormData] = useState(initialFormData);
    const showAdditionalFields = formData?.answers?.findIndex(x => x.answer == true) >= 0;
    const [showFormErrors, setShowFormErrors] = useState(false);
    const model = Schema.Model({
        yesAnswerExplanation: StringType().when(() => {
            return showAdditionalFields ? StringType().isRequired('This field is required') : StringType();
        })
    });
    const handleSubmit = (val, event) => {
        setShowFormErrors(true)
        if (!sectionData.isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            var validationObject = model.check(formData);
            for (const key in validationObject) {
                if (validationObject[key].hasError && (!key.includes("yesAnswerExplanation") || (showAdditionalFields && key.includes("yesAnswerExplanation")))) {
                    return;
                }

            }
            if (formData?.answers?.findIndex(x => x.answer !== true && x.answer !== false) >= 0) {//undefined check
                return;
            }
            if (showAdditionalFields === false || val) {
                var dataTransfer = { ...formData, applicationId: store.currentApplicationId, entityId: store.userInfo.EntityId };
                ViolationService.postViolation(dataTransfer).then((response) => {
                    if (response.data) {
                        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
                    }
                });
            }
        }
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div className="vfAppViolationsPage">
            <Container fluid>
                <Form model={model} onSubmit={handleSubmit} onChange={updateFormData} fluid formValue={formData}>
                    <strong>Surveying Firm Application</strong>
                    <h4 className="mb-3">Violations</h4>
                    <Row className="mb-3">
                        <Col> <Information content={GetAppInformationContent("violations")} /></Col>
                    </Row>
                    {hasLoaded ?
                        <>
                            <Row className="mb-3">
                                <Col>
                                    <GenericViolations
                                        showFormErrors={showFormErrors}
                                        showAdditionalFields={showAdditionalFields}
                                        hideSignature={true}

                                        isReadOnly={!sectionData.isUserEditable}
                                        sectionId={sectionId}
                                        sectionDataId={sectionData.id}
                                        parentTypeId={1}
                                        credentialTypeId={2}
                                    />
                                </Col>
                            </Row>
                            <br />
                            <Issues isUserEditable={true} type={1} sectionId={sectionData.id} />
                            <FormActionButtons nextSectionCallback={nextSectionNavigation} isReadOnly={!sectionData.isUserEditable} backToSectionLink="/firm/vfApp/sections" />
                        </> : <LoadingSpinner />
                    }
                </Form>
            </Container>
        </div>
    )
}
export default Violations;